/**
 * A catalogue price as it reads on a card — "$55", "$1230", "$54.50".
 *
 * The canonical rule is BrochureCatalogueBuilder.FormatUsd in the back office, mirrored again in
 * its brochure-catalogue-seed.ts. Every price we sell today is a whole number of dollars, so
 * "$1,230.00" spends three characters saying nothing; a price that is NOT whole still shows its
 * cents, because dropping those misstates it. The front office rendered toFixed(0) instead, which
 * turned $0.25 into "$0" beside an Add to cart button and "Due today: $0" at the payment step.
 *
 * Deliberately not the rule used by formatUsd in useBilling, which always shows two places — that
 * renders amounts Stripe has already charged, where the cents are the point of the line.
 */
export function formatPriceUsd(amountUsd: number): string {
  // Cart totals are a sum of floats, so 14.1 + 21.2 arrives as 35.300000000000004 and would never
  // look whole. Settle at cents before asking whether there are any.
  const value = Math.round(amountUsd * 100) / 100;

  return value.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
    maximumFractionDigits: 2,
    useGrouping: false,
  });
}
